import { useTranslation } from 'react-i18next';
import { MAIN_SITE_URL } from '@/mocks/categories';

const HERO_IMAGE =
  'https://readdy.ai/api/search-image?query=A%20vibrant%20flat-lay%20of%20diverse%20streetwear%20products%20including%20colorful%20sneakers%2C%20a%20denim%20jacket%2C%20a%20cap%2C%20sunglasses%2C%20a%20backpack%20and%20accessories%20scattered%20on%20a%20warm%20coral%20and%20cream%20background%2C%20bright%20cheerful%20editorial%20fashion%20photography%2C%20energetic%20youthful%20aesthetic%2C%20high%20detail%2C%20harmonious%20composition&width=1600&height=900&seq=usfans-hero&orientation=landscape&nocache=true';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={HERO_IMAGE}
          alt="USFans Spreadsheet product finds"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/55 to-background-50/85" />
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 pt-28 pb-16 text-center">
        <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-sm font-medium mb-6">
          <span className="flex items-center justify-center w-4 h-4">
            <i className="ri-verified-badge-line text-sm" />
          </span>
          {t('hero.badge')}
        </span>

        <h1 className="font-heading font-bold text-foreground-950 text-3xl md:text-5xl leading-tight mb-6">
          {t('hero.title')}
        </h1>

        <p className="text-foreground-700 text-base md:text-lg leading-relaxed max-w-2xl mx-auto mb-9">
          {t('hero.subtitle')}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4">
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm md:text-base hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <span className="flex items-center justify-center w-5 h-5">
              <i className="ri-external-link-line text-base" />
            </span>
            {t('hero.ctaPrimary')}
          </a>
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-lg bg-accent-500 text-background-50 font-semibold text-sm md:text-base hover:bg-accent-600 transition-colors whitespace-nowrap"
          >
            <span className="flex items-center justify-center w-5 h-5">
              <i className="ri-shopping-bag-3-line text-base" />
            </span>
            {t('hero.ctaSecondary')}
          </a>
        </div>

        <p className="mt-8 text-sm text-foreground-600">
          <span className="inline-flex items-center gap-1.5">
            <i className="ri-shield-check-line text-base text-primary-600" />
            {t('hero.trust')}
          </span>
        </p>
      </div>
    </section>
  );
}